<template>
    <div class="category" v-if="page_show">
        <div class="flex__around search-box bb_1">
            <div class="flex align-center search__item" v-link='"/Mall/Search"'>
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1"></span>
                <span class="fs_28 c_b3">&nbsp;请输入关键字搜索</span>
            </div>
        </div>
        <div class="content">
            <div class="sidebar">
                <div class="flex__around__center sidebar__item" v-for="(item,index) in category" :key="index" @click="setCategory(index)">
                    <div class="sidebar__item-tips" :class="first_category_id==item.first_category_id?'active':''"></div>
                    <span class="fs_28 c_1a" :class="first_category_id==item.first_category_id?'fw_600':''">{{item.name}}</span>
                </div>
            </div>
            <div class="category-son">
                <img class="mt_20" v-if="category[category_index].advert_img" :src="category[category_index].advert_img" alt="">
                <div class="flex wrap">
                    <div class="flex__center__between category__item" v-for="(item,index) in category[category_index].lower_category" :key="index" @click="sureCategory(index)">
                        <img class="mt_40" :src="item.cover_img" alt="">
                        <div class="category__item--name ellipsis_one">
                            <span class="fs_24 c_4d lh_40">{{item.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <tab-bar :current='1'></tab-bar>
    </div>
</template>
<script>
export default {
    name: 'Category',
    data(){
        return{
            page_show:false,// 页面展示优化
            first_category_id: '',
            category_index: 0,
            category:[
                {
                    advert_img:'',
                    lower_category:[{}]
                }
            ]
        }
    },
    methods:{ 
        // 切换一级类别
        setCategory(index){
            this.first_category_id=this.category[index].first_category_id;
            this.category_index=index;
        },
        // 选中分类
        sureCategory(index){
            let lower_category=this.category[this.category_index].lower_category;
            let arr=[];
            let two_id='';
            if(index){
                this.$router.push('/mall/List/0/'+lower_category[index].second_category_id);
            }else{
                for(let i=0;i<lower_category.length;i++){
                   arr.push(lower_category[i].second_category_id);
                }
                two_id=arr.join(',');
                this.$router.push('/mall/List/'+lower_category[0].first_category_id+'/0');
            }
        }
    },
    mounted(){
        this.httpPost({
            url:'/Mall/getCategoryData',
            params:{},
            loading:1
        }).then(
            res=>{
                this.page_show=true;
                // 判断进入分类时是否有默认
                if(this.$route.params.id==0){
                    this.first_category_id=res.data.category[0].first_category_id;
                }else{
                    this.first_category_id=this.$route.params.id;
                }
                this.category=res.data.category;
                for(let i=0;i<this.category.length;i++){
                    if(this.first_category_id==this.category[i].first_category_id){
                        this.category_index=i;
                    }
                }
            }
        )
    }
}
</script>
<style scoped>
    .search-box{
        top: 0;
    }
    .content{
        position: fixed;
        top: 90px;
        bottom: 98px;
        width: 100%;
        background: #fff;
    }
    .sidebar{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 170px;
        border-right: 2px solid #e6e6e6;
        overflow: auto;
    }
    .sidebar__item{
        height: 100px;
    }
    .sidebar__item-tips{
        position: absolute;
        left: 0;
        width: 100%;
        height: 40px;
    }
    .active{
        border-left: 6px solid #F93A42;
    }
    .category-son{
        position: absolute;
        left: 170px;
        top: 0;
        bottom: 0;
        padding: 10px 30px;
        overflow-y: scroll;
    }
    .category-son img{
        width: 520px;
        height: 220px;
        border-radius: 10px;
    }
    .category__item img{
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }
    .category__item{
        width: 100px;
        margin-left: 110px;
    }
    .category__item--name{
        text-align: center;
        width: 100px;
    }
    .category__item:nth-child(3n+1){
        margin-left: 0;
    }
</style>





// WEBPACK FOOTER //
// src/pages/mall/Category.vue